import {useSpring, useTransform, AnimatePresence, motion} from "framer-motion";
import React, {useRef, useEffect} from "react";
import {Drawer} from "vaul";
import {spring} from "../lib/utils";
import * as Icon from "../icons";
import * as Dialog from "@radix-ui/react-dialog";

function ModalMobile({
  open,
  onClose,
  title,
  children,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  const themeProgress = useSpring(0, spring.smooth);
  const themeColor = useTransform(
    themeProgress,
    [0, 0.25, 0.5, 0.75, 1],
    ["#999999", "#B3B3B3", "#CCCCCC", "#E6E6E6", "#FFFFFF"],
    {clamp: true}
  );
  const opacity = useTransform(themeProgress, [0, 1], [1, 0], {clamp: true});
  const tagRef = useRef<null | Element>(null);

  useTransform(themeProgress, () => {
    if (!tagRef.current) return;
    tagRef.current.setAttribute("content", themeColor.get());
  });

  useEffect(() => {
    tagRef.current = document.querySelector("meta[name=theme-color]");
  }, []);

  useEffect(() => {
    if (open) themeProgress.set(0);
  }, [open]);

  return (
    <Drawer.Root
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      onClose={() => themeProgress.set(1)}
      onDrag={(_, progress) => themeProgress.jump(progress)}
      onRelease={(_, open) => themeProgress.set(!open ? 1 : 0)}
    >
      <Drawer.Portal>
        <AnimatePresence>
          {open && (
            <Dialog.DialogOverlay forceMount asChild>
              <motion.div
                className="fixed inset-0 z-40 bg-black/40"
                style={{opacity}}
              />
            </Dialog.DialogOverlay>
          )}
        </AnimatePresence>
        <Drawer.Content className="bg-white flex flex-col rounded-t-3xl mt-24 fixed bottom-0 left-0 right-0 pb-2 z-40 gap-1">
          <div className="absolute left-1/2 -translate-x-1/2 bg-slate-200 h-1 w-16 rounded-full mx-auto my-2" />
          <div className="flex justify-between items-start mt-4 px-4">
            <Drawer.Title className="text-3xl mt-2 [text-wrap:balance]">
              {title}
            </Drawer.Title>
            <Drawer.Close
              className="p-4 rounded-xl opacity-50
                hover:opacity-100 hover:bg-slate-500/5
              "
            >
              <Icon.Close />
            </Drawer.Close>
          </div>
          {children}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

export {ModalMobile};
